import {Types2D, TypesNotification} from "@dp-instant/interfaces";
import {View} from "@dp-instant/2d";
import {Action, di, lazyGet} from "@dp-instant/core";
import {log} from "@dp-instant/utils";
import {LevelStartAction} from "@dp-instant/gameflow";
import {CTXLevelProgress} from "@game/coregame/interfaces/CTXLevelProgress";
import {LevelData} from "@game/coregame/interfaces/LevelData";
import {InputManager} from "@game/coregame/managers/InputManager";
import {ContinentModel} from "@game/coregame/model/ContinentModel";
import {GameModel} from "@game/coregame/model/GameModel";
import {GameState} from "@game/coregame/model/GameState";
import Root from "@game/coregame/view/Root";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable, interfaces} from "inversify";

@injectable()
export class LevelStartActionSIO extends LevelStartAction<string> {
    @inject(Types2D.rootView)
    private root: Root;

    @inject(TypesGame.model)
    private model: GameModel;

    @inject(TypesGame.inputManager)
    private inputManager: InputManager;

    private levelData: LevelData;
    private contextData: CTXLevelProgress | null;

    protected async beforeLaunch(): Promise<void> {
        await this.model.disposeCurrentLevel();
        if (!this.data) {
            await this._contextChangePromise;
            this.contextData = this.model.getContextData();
        }

        const levelId = this.data || this.contextData?.l || GameModel.LEVELS_PREDEFINED[0];

        if (levelId && this.model.levels[levelId]) {
            // level already loaded
            await super.beforeLaunch();
        } else {
            this.root.overlay.blur();
            this.root.spinner.show();
            this.model.state = GameState.LOADING;
            const loadRoutine = async () => {
                this.levelData = await di
                    .get<Action<string, LevelData>>(TypesGame.actions.loadLevel)
                    .run(levelId);
            };

            await Promise.all([loadRoutine(), super.beforeLaunch()]);
        }
    }

    protected async launch(levelId: string): Promise<any> {
        console.log("123");
        this.root.progressBar.hide();
        this.root.spinner.hide();
        this.root.overlay.unblur();

        const fieldViewInstance = di.get(TypesGame.views.fieldClass) as View;
        di.bind(TypesGame.views.fieldInstance).toConstantValue(fieldViewInstance);
        this.root.addChild(fieldViewInstance);

        const levelModel =
            this.model.levels[levelId] ||
            di.get<ContinentModel>(TypesGame.levelModel).init(this.levelData);

        levelModel.stageLevel = this.contextData?.c || 0;
        this.model.setCurrentContinent(levelModel);
        if (!this.social.inSolo) {
            let notificationAction = lazyGet<Action>(TypesNotification.start);
            await notificationAction?.run();
        }
        await super.launch();
        this.inputManager.start();
        if (this.social.inSolo) {
            this.model.state = GameState.LOBBY;
        } else {
            this.model.startStage();
        }
    }

    protected sendPush(actionKey: interfaces.ServiceIdentifier<any>, actionPayload?: any) {
        // FIXME: lazy hot fix to workaround sendPush (push is sending after level loaded by direct action call)
    }
}
